import { FilterDto } from '../../../types/FilterDto';
import { getFilters } from '../../admin/Dictionaries/api/basicGenericTable';
import type { TFunction } from "i18next";

export const getFiltersProfessionals = async (t: TFunction<[string], undefined>): Promise<FilterDto[]> => {
    
    const serviceIndicatorsFilter: FilterDto = await getFilters("serviceIndicators");
    serviceIndicatorsFilter.values = [
        { key: -1, value: t("professional:filters.withoutService") },
        ...(serviceIndicatorsFilter.values ?? [])
    ];
    serviceIndicatorsFilter.description = t ? t("professional:filters.serviceIndicators"): "ServiceIndicators";


    const claimProfessionalTypeFilter: FilterDto = await getFilters("claimProfessionalType");
    claimProfessionalTypeFilter.values = [
        { key: -1, value: t("professional:filters.withoutProfessionalType") },
        ...(claimProfessionalTypeFilter.values ?? [])
    ];
    claimProfessionalTypeFilter.description = t ? t("professional:filters.claimProfessionalType") : "ClaimProfessionalType";

    return [claimProfessionalTypeFilter, serviceIndicatorsFilter];
};
